import React, { useState } from "react";
import orca from "../Images/ORCA.png";
import config from "../config";

const Header = ({ currentPage, setCurrentPage, setIsLoggedIn, setUserRole }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  const navItems = [
    { name: "Home", page: "home" },
    { name: "About", page: "about" },
    { name: "Contact", page: "contact" },
    ...(!isLoggedIn ? [{ name: "Login", page: "login" }] : []),
  ];

  const handleLogout = async () => {
    try {
      const adminRaw = localStorage.getItem("admin");
      if (adminRaw) {
        const admin = JSON.parse(adminRaw);
        if (admin?.username && admin.username !== "superadmin") {
          const formData = new URLSearchParams();
          formData.append("username", admin.username);
          await fetch(`${config.API_BASE_URL}/Admin/logout`, {
            method: "POST",
            body: formData,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });
        }
      }
    } catch (err) {
      console.warn("⚠️ Logout API error:", err);
    } finally {
      // Always clear session regardless of API result
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userRole");
      localStorage.removeItem("admin");
      localStorage.removeItem("user");
      localStorage.removeItem("currentPage");
      setIsLoggedIn(false);
      setUserRole(null);
      setCurrentPage("login");
    }
  };

  return (
    <header className="bg-gray-900/95 backdrop-blur-md border-b border-gray-800 sticky top-0 z-50 shadow-xl">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <div className="bg-white px-6 py-3 rounded-lg shadow-lg">
              <img
                src={orca}
                alt="ORCA Helpdesk Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.page}
                onClick={() => setCurrentPage(item.page)}
                className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                  currentPage === item.page
                    ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg"
                    : "text-gray-300 hover:text-white hover:bg-gray-800"
                }`}
              >
                {item.name}
              </button>
            ))}

            {/* Logout Button — visible lang kapag naka-login */}
            {isLoggedIn && (
              <button
                onClick={handleLogout}
                className="px-6 py-2 rounded-lg font-semibold transition-all duration-300 text-red-400 hover:text-white hover:bg-red-600"
              >
                Logout
              </button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-300 hover:text-white p-2"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-2 animate-fadeIn">
            {navItems.map((item) => (
              <button
                key={item.page}
                onClick={() => {
                  setCurrentPage(item.page);
                  setIsMenuOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition-all ${
                  currentPage === item.page
                    ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
                    : "text-gray-300 hover:bg-gray-800"
                }`}
              >
                {item.name}
              </button>
            ))}

            {/* Mobile Logout Button */}
            {isLoggedIn && (
              <button
                onClick={() => { handleLogout(); setIsMenuOpen(false); }}
                className="w-full text-left px-4 py-3 rounded-lg font-semibold transition-all text-red-400 hover:bg-red-600 hover:text-white"
              >
                Logout
              </button>
            )}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;